<template>
  <section>
    <Feature :title="$t('QUOTATION_HISTORY_REPORT')" :iconClass="'fa-history'">
      <Table :columns="columnList" :data="quotationList">
      </Table>
      <ButtonRow>
        <Button type="primary" @click="downloadExcel" slot="1">{{ $t('DOWNLOAD') }}</Button>
        <Button type="primary" @click="Back" slot="2">{{ $t('BACK') }}</Button>
      </ButtonRow>
      <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
        v-model="scalePricesModel" :title="$t('SCALE_PRICE')">
        <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
          <Table :columns="scalePriceColumnList" :data="scalePrices" max-height="800"></Table>
        </div>
      </Modal>
    </Feature>
  </section>
</template>
  
<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import moment from "moment"

export default {
  name: "HistoryRfqReport",
  created() {
    const vueInstance = this
    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
      .get("history-report/details/group/" + vueInstance.getHistoryReportGroupId())
      .then((response) => {
        console.log(response)
        vueInstance.toggleLoading(false)
        if (response.data) {
          vueInstance.quotationList = response.data.details
          vueInstance.quotationList.forEach(quotation => {
            let init = 1
            if (quotation.scalePrices) {
              init = quotation.scalePrices.length + 1
            } else {
              quotation.scalePrices = []
            }

            for (let i = init; i < 6; i++) {
              quotation.scalePrices.push({
                item: i,
                scalePrice: "",
                scaleQuantity: ""
              })
            }
          })
        } else {
          vueInstance.$Notice.success({
            title: Translate("COMMON_MESSAGE_INFO"),
            desc: Translate("COMMON_MESSAGE_INFO"),
            render: h => {
              return h('span', [
                Translate("COMMON_TEXT_NOTHING")
              ])
            }
          });
          vueInstance.Back()
        }
      })
      .catch((error) => {
        vueInstance.toggleLoading(false)
        vueInstance.Back()
      })
  },
  data() {
    return {
      quotationList: [],
      scalePrices: [],
      quotationUuid: '',
      scalePricesModel: false,
      columnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_KEY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupId",
          align: "center",
          width: 200
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PART_NO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "deltaPart",
          align: "center",
          width: 200
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PART_NO_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "deltaPartDesc",
          align: "center",
          width: 200
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_PN')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "vendorPartNo",
          align: "center",
          width: 200
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "plant",
          align: "center",
          width: 100
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "currency",
          align: "center",
          width: 100
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.quotationList[params.index].price
              },
              on: {
                'on-change': (event) => {
                  this.quotationList[params.index].price = event.target.value
                }
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM') + '<br>' + this.$t('VALID_TO')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (!this.quotationList[params.index].validFrom) {
              this.quotationList[params.index].validFrom = moment().format("YYYY-MM-DD")
            }
            if (!this.quotationList[params.index].validTo) {
              this.quotationList[params.index].validTo = getDefaultValidTo()
            }
            return h("div", [
              h('DatePicker', {
                props: {
                  value: this.quotationList[params.index].validFrom,
                  type: 'date',
                  format: 'yyyy-MM-dd',
                  placeholder: 'Select Date',
                  transfer: true
                },
                on: {
                  'on-change': (val) => {
                    this.quotationList[params.index].validFrom = val;
                  }
                }
              }),
              h('DatePicker', {
                props: {
                  value: this.quotationList[params.index].validTo,
                  type: 'date',
                  format: 'yyyy-MM-dd',
                  placeholder: 'Select Date',
                  transfer: true
                },
                on: {
                  'on-change': (val) => {
                    this.quotationList[params.index].validTo = val;
                  }
                }
              })
            ]);
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-reorder",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.scalePrices = params.row.scalePrices
                  this.quotationUuid = params.row.uuid
                  this.scalePricesModel = true
                },
              },
            })
          }
        }
      ],
      scalePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ITEM')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE'); + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePrices[params.index].scaleQuantity
              },
              on: {
                'on-change': (event) => {
                  this.scalePrices[params.index].scaleQuantity = event.target.value
                }
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          render: (h, params) => {
            return h('Input', {
              props: {
                type: 'text',
                value: this.scalePrices[params.index].scalePrice
              },
              on: {
                'on-change': (event) => {
                  this.scalePrices[params.index].scalePrice = event.target.value
                }
              }
            })
          }
        }
      ]
    }
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getModalSize", "getWindowsWidth", "getHistoryReportGroupId"]),
    ...mapActions(["toggleLoading"]),
    downloadExcel() {

    },
    Back() {
      this.$router.push({ name: 'QUOTATION_HISTORY_REPORT' })
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

</script>
  
<style scoped></style>
  